import CheckoutForm from "../checkout_form";

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {useEffect, useState} from "react";
import {allProjects} from "../../../pages/shop";
import {tiers} from "../retainer/retainerPricingComponent";
import {sendSlackMessageTracked} from "../../../models/notifications";


const products = [
    {
        id: 1,
        name: "Women's Basic Tee",
        cost: '$32.00',
        color: 'Gray',
        imageSrc: 'https://firebasestorage.googleapis.com/v0/b/herstory-36c57.firebasestorage.app/o/website%2Fmedia%2Fserious-arms-crossed.webp?alt=media&token=be7b0511-340b-4fe0-b57a-3a65b1ea8c03',
        imageAlt: "Front of women's basic tee in heather gray.",
    },
    // More products...
]

export default function CheckoutPageView({product_id}) {
    const [cartData, setCartData] = useState([])
    const [totalCost, setTotalCost] = useState(0)
    const [stripePromise, setStripePromise] = useState(null)
    const [stripeLoadFailed, setStripeLoadFailed] = useState(false)

    useEffect(() => {
        loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_51OXEZbEtOurAbnzKrvuWEULuMoOoc0dMClXeCnQRoz1i5DWGwO7A0V17QuUBdAT7jKkeUvAmXK9c1hIsWQ4Edba600EKImzKuv")
            .then(setStripePromise)
            .catch(() => setStripeLoadFailed(true))
    }, [])

    useEffect(() => {

        sendSlackMessageTracked("🇮🇶Client has reached the checkout page.")
        // Pull cart from Index
        if (Boolean(product_id)) {
            const allTiers = tiers
            for (const tier of allTiers) {
                if (tier.key === product_id) {
                    console.log("Found the match", tier.key)
                    setCartData([{
                        id: tier.key,
                        name: tier.name,
                        family: "retainer",
                        cost: tier.cost,
                        description: tier.description,
                        imageSrc: tier.imageSrc,
                        imageAlt: tier.imageAlt,
                    }])
                    break
                }
            }
            return
        }

        // Pulls cartData from local storage
        let selectedItems = localStorage.getItem("selectedItems")
        if (!Boolean(selectedItems)) {
            // window.open("/seo-retainer")
            return
        }

        selectedItems = JSON.parse(localStorage.getItem("selectedItems"))
        if (selectedItems.length === 0) {
            // window.open("/seo-retainer", "_self")
            return
        }
        let itemsInStorage = []
        for (let i = 0; i < selectedItems.length; i++) {
            const family = selectedItems[i]["family"]
            const id = selectedItems[i]["id"]
            let familyProjects = allProjects[family]["projects"]
            for (let j = 0; j < familyProjects.length; j++) {
                if (familyProjects[j].id === id) {
                    itemsInStorage.push(familyProjects[j])
                }
            }
        }
        setCartData(itemsInStorage)
    }, []);

    useEffect(() => {
        let tempTotal = 0
        for (let i = 0; i < cartData.length; i++) {
            tempTotal += parseFloat(cartData[i].cost)
        }
        console.log("Updating teh amount", product_id)
        setTotalCost(tempTotal)
    }, [cartData])


    const options = {
        // TODO: passing the client secret obtained from the server
        clientSecret: 'pi_3QXFztEtOurAbnzK1UxUQCEz_secret_PiQ7PgD1nJJlhPSMYydkxwkgk',
    };
    return (
        <div className="bg-white">
            <div className="mx-auto max-w-7xl px-4 pb-16 pt-4 sm:px-6 sm:pb-24 sm:pt-8 lg:px-8 xl:px-2 xl:pt-14">
                <h1 className="sr-only">Checkout</h1>

                <div className="mx-auto grid max-w-lg grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
                    <div className="mx-auto w-full max-w-lg">
                        <h2 className="sr-only">Order summary</h2>

                        <div className="flow-root">
                            <ul role="list" className="-my-6 divide-y divide-gray-200">
                                {cartData.map((product) => (
                                    <li key={product.id} className="flex space-x-6 py-6">
                                        {
                                            product.imageSrc &&
                                            <img
                                                alt={product.imageAlt}
                                                src={product.imageSrc}
                                                className="size-24 flex-none rounded-md bg-gray-100 object-cover"
                                            />
                                        }
                                        <div className="flex-auto">
                                            <div
                                                className="space-y-1 sm:flex sm:items-start sm:justify-between sm:space-x-6">
                                                <div className="flex-auto space-y-1 text-sm font-medium">
                                                    <h5 className="text-gray-900">
                                                        <div>{product.name}</div>
                                                    </h5>
                                                    <p className="text-gray-500 sm:block text-base">${product.cost}</p>
                                                    <p className="text-gray-900 text-base">{product.description}</p>
                                                </div>

                                                <button type="button"
                                                        className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                                                        onClick={() => {
                                                            // Removes the ID from the list
                                                            let tempArray = []
                                                            tempArray = cartData.filter(obj => obj.id !== product.id);
                                                            setCartData(tempArray)
                                                            localStorage.setItem("selectedItems", JSON.stringify(tempArray))
                                                        }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <dl className="mt-10 space-y-6 text-sm font-medium text-gray-500">
                            {
                                cartData.map((product) => (
                                    <div className="flex justify-between">
                                        <dt>{product.name}</dt>
                                        <dd className="text-gray-900">${product.cost}</dd>
                                    </div>
                                ))
                            }
                            <div className="flex justify-between">
                                <dt>Taxes</dt>
                                <dd className="text-gray-900">Included</dd>
                            </div>
                            <div className="flex justify-between border-t border-gray-200 pt-6 text-gray-900">
                                <dt className="text-base">Total</dt>
                                <dd className="text-base">${totalCost}</dd>
                            </div>
                        </dl>
                    </div>


                    <div className="mx-auto w-full max-w-lg">

                        <div>

                            <div className="">
                                {stripeLoadFailed ? (
                                    <p className="text-sm text-red-600 py-4">
                                        Payment is temporarily unavailable. Please contact us to complete your order.
                                    </p>
                                ) : (
                                    <Elements stripe={stripePromise} options={options}>
                                        <CheckoutForm/>
                                    </Elements>
                                )}
                            </div>

                            <button
                                type="button"
                                className="flex w-full items-center justify-center rounded-md border border-transparent bg-black py-2 text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
                            >
                                <span className="sr-only">Pay with Apple Pay</span>
                                <svg fill="currentColor" viewBox="0 0 50 20" className="h-5 w-auto">
                                    <path
                                        d="M9.536 2.579c-.571.675-1.485 1.208-2.4 1.132-.113-.914.334-1.884.858-2.484C8.565.533 9.564.038 10.374 0c.095.951-.276 1.884-.838 2.579zm.829 1.313c-1.324-.077-2.457.751-3.085.751-.638 0-1.6-.713-2.647-.694-1.362.019-2.628.79-3.323 2.017-1.429 2.455-.372 6.09 1.009 8.087.676.99 1.485 2.075 2.552 2.036 1.009-.038 1.409-.656 2.628-.656 1.228 0 1.58.656 2.647.637 1.104-.019 1.8-.99 2.475-1.979.771-1.122 1.086-2.217 1.105-2.274-.02-.019-2.133-.828-2.152-3.263-.02-2.036 1.666-3.007 1.742-3.064-.952-1.408-2.437-1.56-2.951-1.598zm7.645-2.76v14.834h2.305v-5.072h3.19c2.913 0 4.96-1.998 4.96-4.89 0-2.893-2.01-4.872-4.885-4.872h-5.57zm2.305 1.941h2.656c2 0 3.142 1.066 3.142 2.94 0 1.875-1.142 2.95-3.151 2.95h-2.647v-5.89zM32.673 16.08c1.448 0 2.79-.733 3.4-1.893h.047v1.779h2.133V8.582c0-2.14-1.714-3.52-4.351-3.52-2.447 0-4.256 1.399-4.323 3.32h2.076c.171-.913 1.018-1.512 2.18-1.512 1.41 0 2.2.656 2.2 1.865v.818l-2.876.171c-2.675.162-4.123 1.256-4.123 3.159 0 1.922 1.495 3.197 3.637 3.197zm.62-1.76c-1.229 0-2.01-.59-2.01-1.494 0-.933.752-1.475 2.19-1.56l2.562-.162v.837c0 1.39-1.181 2.379-2.743 2.379zM41.1 20c2.247 0 3.304-.856 4.227-3.454l4.047-11.341h-2.342l-2.714 8.763h-.047l-2.714-8.763h-2.409l3.904 10.799-.21.656c-.352 1.114-.923 1.542-1.942 1.542-.18 0-.533-.02-.676-.038v1.779c.133.038.705.057.876.057z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
